import { UAParser } from "ua-parser-js";
import { useMemo } from "react";

// Plain function so non-React code (app boot, loggers) can read it too.
export const getClientInfo = () => {
  // withFeatureCheck unmasks iPads, whose default "desktop site" UA claims
  // to be a Macintosh; without it every iPad reads as a desktop Mac.
  const result = new UAParser().getResult().withFeatureCheck();
  const deviceType = result.device.type || "desktop";
  const deviceModel = [result.device.vendor, result.device.model].filter(Boolean).join(" ");

  return {
    os: {
      name: result.os.name,
      version: result.os.version,
    },
    browser: {
      name: result.browser.name,
      version: result.browser.version,
    },
    device: {
      type: deviceType,
      vendor: result.device.vendor,
      model: result.device.model,
    },
    // One-line human summary for bug reports, e.g.
    // "Safari 17.5 on macOS 10.15.7 (tablet, Apple iPad)".
    summary:
      `${result.browser.name} ${result.browser.version} on ` +
      `${result.os.name} ${result.os.version} ` +
      `(${deviceType}${deviceModel ? `, ${deviceModel}` : ""})`,
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio,
    },
    language: navigator.language || navigator.userLanguage,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    connection: navigator.connection?.effectiveType,
    userAgent: navigator.userAgent,
  };
};

export const useClientInfo = () => useMemo(getClientInfo, []);
